import React, { Fragment, useEffect } from 'react'
import { useFormik } from 'formik'
import AntecendentesImplicado from './AntecedentesImplicado'
import { Modal } from 'react-bootstrap'
import { Button, Form } from 'react-bootstrap'
import validationSchemasRespuesta from '../../../common/validation-Shecmas-Procesar-Respuesta'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Auth,LoadingComponent } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { configuracionFormAction9, obtenerCasoImplicado, obtenerDatosLlaves, PostRespuestaCobro } from '../../../store/actions/encargado-cia-action'
import AntecedentesEnvioRecobro from './AntecedentesEnvioRecobro'
import AccionesRespuestaRecobro from './AccionesRespuestaRecobro'
import RecepcionarRespuestaCIA from './RecepcionarRespuestaCIA'

const FormularioPrincipal = () => {
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const { respuestaRecobro, casoImplicado, llaves, clasificaRespuesta, motivo, estadoAccion } = data_encargado_cia
  const {state}=useLocation()
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :20
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:99061000
  const [loading, setLoading]=useState(false)
  const dispatch = useDispatch()
  const { rutUsuario } = Auth.currentUser()
  const history =useNavigate() 
  const queryState=state?.myQueryState && state.myQueryState
  const handleShow = () => setShow(true)
  const [porConvenioOld, setPorConvenioOld] = useState('')
  const [miRecobroNo, setMirecobroNo] = useState('')
  const [nuevoNeto, setNuevoNeto] = useState('')
  const [disabledMontoNeto, setDisabledMontoNeto] = useState(true)
  const [show, setShow] = useState(false)
  const [siguienteEstado, setSiguienteEstado] = useState(false)

useEffect(() => {     
  dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation ,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}))
}, [dispatch])

useEffect(() => {
  if (llaves){
    setLoading(true)
    let query = Buffer.from(JSON.stringify({ "idImplicado":llaves["idImplicado"] , "idCaso": llaves["idCaso"] })).toString('base64');
    dispatch(obtenerCasoImplicado(query))
    .then(()=>{
      let query = Buffer.from(
        JSON.stringify({ idform: 9, rutcia: idOrganizacionCaso})
      ).toString('base64')
      dispatch(configuracionFormAction9(query))
    })    
    .then(()=>setLoading(false))
  }
}, [dispatch, llaves]);

const handleClose = () => {  
  if (respuestaRecobro && respuestaRecobro.respuestaRecobro["code"]===-1) {
    setShow(false)
  } else {    
    history('/area-trabajo-recupero-companias',{state:{queryState}})
    setShow(false)
  }
}
  const formik = useFormik({
    initialValues: {
      idCaso: '',
      idImplicadoCaso: '',
      idOrganizacion: '',
      porcConvenio: '',
      porcConvenioOld: '',
      montoRecobro: '',
      motivoRespuestaCIA: '',
      glosaMotivoRespuesta: '',
      fechaRespuesta: '',
      comentarioAnalista: '',
      estadoRespuesta: '',
      accionRespuesta: '',
      ciaImplicado: '',
      idUsuario: ''
    },
    validationSchema: validationSchemasRespuesta,
   
    onSubmit: (formData) => {
      const motivoRespuesta =motivo?.motivo?.find((m) => m.id === parseInt(formik.values.motivoRespuestaCIA))
      const clasRespuesta = clasificaRespuesta?.clasificaRespuesta?.find((m) => m.id === parseInt(formik.values.respuesta))

      const estado_Accion = estadoAccion && estadoAccion.estadoAccion
      // const data={...formik.values}
      const data = { ...formData }
      data['idCaso'] = llaves && llaves['idCaso']
      data['idImplicadoCaso'] = llaves && llaves['idImplicado']
      data['idOrganizacion'] = llaves && llaves['idOrgCaso']
      data['porcConvenioOld'] = parseInt(porConvenioOld)
      data['glosaMotivoRespuesta'] = motivoRespuesta?.nombre;
      data['estadoRespuesta'] = estado_Accion['estadoRpta']
      data['accionRespuesta'] = estado_Accion['accionRpta']
      data['ciaImplicado'] = casoImplicado && casoImplicado.casoImplicado[0]['CiaImplicado']

      data['montoRecobro'] = miRecobroNo && miRecobroNo
      data['idUsuario'] = rutUsuario && rutUsuario
      
      if (data.respuesta == 227004 && data.motivoRespuestaCIA == 228005) {//(227004) Pendiente Condicionado - (228005) Sólo Daños Traseros
        data['nuevoMontoNeto'] = nuevoNeto && nuevoNeto
      }
      data['chkSiguienteEstado'] = siguienteEstado;
      data['estadoCaso'] = estado_Accion['estadoCaso'];
      data['glosaClasRespuesta'] = clasRespuesta?.nombre;
      
      //console.log("data: ", data); 
      dispatch(PostRespuestaCobro(data))
      handleShow()
    }
  })
  return (
    <>
     <LoadingComponent show={loading}/>
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Respuesta de la información enviada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      { respuestaRecobro ? respuestaRecobro.respuestaRecobro["message"]:"Enviando..."} 
        </Modal.Body>
      {respuestaRecobro && <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>
            Aceptar
          </Button>
        </Modal.Footer>}
      </Modal>
      <Form onSubmit={formik.handleSubmit}>
        {/*<AntecendentesImplicado formik={formik} />*/}
        <AntecedentesEnvioRecobro
          formik={formik}
          setPorConvenioOld={setPorConvenioOld}
          setMirecobroNo={setMirecobroNo}
          disabledMontoNeto={disabledMontoNeto}
          setNuevoNeto={setNuevoNeto}
        />
        <RecepcionarRespuestaCIA 
          formik={formik} 
          setDisabledMontoNeto={setDisabledMontoNeto}
          siguienteEstado={siguienteEstado}
          setSiguienteEstado={setSiguienteEstado}
        />
        <AccionesRespuestaRecobro
          formik={formik}
          porConvenioOld={porConvenioOld}
          miRecobroNo={miRecobroNo}
        />
      </Form>
    </>
  )
}

export default FormularioPrincipal
